import Box from '@mui/material/Box'
import {useEffect, useState} from 'react'
import ApiService from '../../../common/ApiCalls'
import {Select, Text} from '../../1elements'
import {titleCase} from '../../../services/util/formatter'

const ProvinceDropDown = ({value, onChange, onEditMode, selectedCountry}) => {
    const [options, setOptions] = useState([])


    useEffect(()=>{
        const extractProvinceOptions = (allLandingOptions) => {
            if (selectedCountry?.location_name?.toLocaleLowerCase() !== 'canada') return []

            const provinceOptions = allLandingOptions.filter((option)=> !option.is_country)
            provinceOptions.forEach((province) => province.location_name = titleCase(province.location_name))
            return provinceOptions.sort((a, b) => a.location_name.localeCompare(b.location_name))
        }

        const getProvinceOptions = async () => {
            const allLandingOptions = await ApiService().getAllLandingOptions()

            setOptions(extractProvinceOptions(allLandingOptions))
        }
        getProvinceOptions()
    }, [selectedCountry])

    const selectValue = value
      ? options.find(option => option.location_name?.toLocaleLowerCase() === value.location_name?.toLocaleLowerCase())
      : ''

    return (
        <Box sx={{ maxWidth: '400px', minWidth: 250, position: 'relative' }}>
            <Text type={'h9'} style={{ position: 'absolute', top: -20 }}>Province/State</Text>
            <Select options={options} optionLabelKey={'location_name'} value={ selectValue ?? '' } onChange={onChange} helperText={'Select One'}
                     disabled={!onEditMode || selectedCountry?.location_name?.toLocaleLowerCase() !== 'canada'}/>
        </Box>
    )
}

export default ProvinceDropDown
